import data from "../../.sourceflow/articles.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getArticles = ({ url_slug = null, type = null, limit = null, locale = "en" } = {}) => {
  const filteredCollection = (data.category_values || []).filter(
    (item) => item.type && item.type[locale] !== "Case Studies",
  );

  const collection = new BaseCollection(filteredCollection, locale)
    .orderBy((i) => parseInt(i.order[locale]))
    .map((i) => ({
      ...i,
      href: `/${data.url_pattern.replace("[type]", i.type[locale] ? i.type[locale].trim().toLowerCase() : "blogs")}/${
        i.url_slug
      }`,
    }));

  if (url_slug) {
    return collection.getJsonItem(url_slug, "url_slug");
  }

  if (type && limit) {
    return collection
      .getItems()
      .filter((i) => i.type.toLowerCase().includes(type.toLowerCase()))
      .slice(0, limit);
  }

  if (type) {
    return collection.getItems().filter((i) => i.type.toLowerCase().includes(type.toLowerCase()));
  }

  if (limit) {
    return collection.getItems().slice(0, limit);
  }

  return collection.getItems();
};
